import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

const hasDefaultVuexRootState = window.__defaultVuexState && window.__defaultVuexState.root !== undefined && typeof window.__defaultVuexState.root === 'object';
const defaultRootState = Object.assign({}, hasDefaultVuexRootState ? window.__defaultVuexState.root : {});

const store = new Vuex.Store({
    modules,

    state: Object.assign({
        subscription_price_monthly_in_cents: 0,
        subscription_price_yearly_in_cents: 0,
        interval_price_in_cents: 0,
        support_email: trans('global.system_email'),

        // this will load the default vuex state from the backend. Check VuexService class.
        // it will override the values set above with the default values coming from the backend.
    }, defaultRootState),

    mutations: {},

    actions: {},

    getters: {}
})

export default store
